export default "__VITE_ASSET__DzSmwilh__"